export default "__VITE_PUBLIC_ASSET__e2a15471__"